"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TickRow = void 0;
class TickRow {
    constructor(obj) {
        // Take in an object, and assign every property from that
        // object onto this newly created object.
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.TickRow = TickRow;
//# sourceMappingURL=TickRow.js.map